import { render, staticRenderFns } from "./webIntroduce.vue?vue&type=template&id=4cf4274a&scoped=true"
import script from "./webIntroduce.vue?vue&type=script&lang=js"
export * from "./webIntroduce.vue?vue&type=script&lang=js"
import style0 from "./webIntroduce.vue?vue&type=style&index=0&id=4cf4274a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf4274a",
  null
  
)

export default component.exports